import React from 'react';
import ManCrossPageFooter from '../components/ManCrossPageFooter';

const fmt = (v) => `$${v}M COP`;

const ManCrossPageRoiRiesgo = ({ reportData, headerText, pageNumber }) => {
    const payload = reportData?.payload || {};
    const roi     = payload.roi || {};

    const expoMin  = roi.exposicion_min  ?? 370;
    const expoMax  = roi.exposicion_max  ?? 1775;
    const invMin   = roi.inversion_min   ?? 19;
    const invMax   = roi.inversion_max   ?? 30;
    const ratio    = roi.ratio           ?? '12:1';

    const accidenteItems = roi.accidente_items || [
        { label: 'Incapacidad + atención médica',               value_range: '$45–80M COP' },
        { label: 'Investigación + COPASST + Inspección MinTrabajo', value_range: '$20–35M COP' },
        { label: 'Multa SGSST (Ley 1562/2012)',                  value_range: '$30–500M COP' },
        { label: 'Pérdida productividad + reemplazo',           value_range: '$25–60M COP' },
        { label: 'Daño reputacional + cliente',                  value_range: '$50–200M COP' },
        { label: 'Costos legales si es fatal',                   value_range: '$200–900M COP' },
    ];

    const intervencionItems = roi.intervencion_items || [
        { label: 'Coaching individual a supervisores críticos',  value_range: '$4–6M COP' },
        { label: 'Taller Stop Work — supervisores',             value_range: '$3–5M COP' },
        { label: 'Programa bienestar físico operarios',         value_range: '$6–10M COP' },
        { label: 'Talleres disciplina y hábitos seguros',        value_range: '$4–6M COP' },
        { label: 'Conversaciones seguridad en planta',          value_range: '$2–3M COP' },
        { label: 'Activación dashboard Talentha®',              value_range: 'Incluido en contrato', highlight: true },
    ];

    const multiple = Math.round(expoMin / invMax);

    return (
        <div className="mgcr-drivers-page">
            <div className="mgcr-page-header">
                <span className="mgcr-page-header-text">{headerText}</span>
                <span className="mgcr-page-header-num">{pageNumber}</span>
            </div>

            <div className="keep-blankspace" />

            <div className="mgcr-dx-title-area">
                <h2 className="mgcr-dx-main-title">ROI del Riesgo</h2>
                <p className="mgcr-dx-subtitle">Inversión vs. Pérdida</p>
            </div>

            {/* Callout */}
            <div className="mgcr-roi-callout">
                El plan de intervención vale <strong>{multiple}×</strong> menos que un solo accidente grave en planta.
            </div>

            {/* Dos paneles */}
            <div className="mgcr-roi-panels">

                {/* Panel izquierdo — Accidente */}
                <div className="mgcr-roi-panel mgcr-roi-panel--accident">
                    <div className="mgcr-roi-panel-header mgcr-roi-panel-header--accident">
                        <div className="mgcr-roi-panel-title">COSTO DE UN ACCIDENTE GRAVE EN PLANTA</div>
                        <div className="mgcr-roi-panel-source">(Basado en datos FASECOLDA 2023 — Sector Industrial Colombia)</div>
                    </div>
                    <div className="mgcr-roi-panel-body">
                        {accidenteItems.map((item, i) => (
                            <div key={i} className="mgcr-roi-row">
                                <span className="mgcr-roi-row-label">{item.label}</span>
                                <span className="mgcr-roi-row-value mgcr-roi-row-value--accident">{item.value_range}</span>
                            </div>
                        ))}
                    </div>
                    <div className="mgcr-roi-panel-footer mgcr-roi-panel-footer--accident">
                        <span className="mgcr-roi-footer-label">EXPOSICIÓN TOTAL ESTIMADA</span>
                        <span className="mgcr-roi-footer-value">{fmt(expoMin)}–{expoMax}M COP</span>
                    </div>
                </div>

                {/* Panel derecho — Intervención */}
                <div className="mgcr-roi-panel mgcr-roi-panel--plan">
                    <div className="mgcr-roi-panel-header mgcr-roi-panel-header--plan">
                        <div className="mgcr-roi-panel-title">COSTO DEL PLAN DE INTERVENCIÓN 90 DÍAS</div>
                        <div className="mgcr-roi-panel-source">(Estimación para planta con alcance actual)</div>
                    </div>
                    <div className="mgcr-roi-panel-body">
                        {intervencionItems.map((item, i) => (
                            <div key={i} className="mgcr-roi-row">
                                <span className="mgcr-roi-row-label">{item.label}</span>
                                <span className={`mgcr-roi-row-value ${item.highlight ? 'mgcr-roi-row-value--included' : 'mgcr-roi-row-value--plan'}`}>
                                    {item.value_range}
                                </span>
                            </div>
                        ))}
                    </div>
                    <div className="mgcr-roi-panel-footer mgcr-roi-panel-footer--plan">
                        <span className="mgcr-roi-footer-label">INVERSIÓN TOTAL ESTIMADA</span>
                        <span className="mgcr-roi-footer-value">{fmt(invMin)}–{invMax}M COP</span>
                    </div>
                </div>
            </div>

            {/* ROI mínimo */}
            <div className="mgcr-roi-minimum">
                <strong>ROI MÍNIMO:</strong>{' '}
                {fmt(expoMin)} ÷ {fmt(invMax)} = <span className="mgcr-roi-ratio">{ratio}</span>
                {' '}— por cada peso invertido en el plan, se evitan mínimo ${multiple} en costos de accidente.
            </div>

            {/* Conclusión */}
            <div className="mgcr-roi-implication">
                <strong>Esto implica que:</strong> La pregunta no es si la empresa puede costear el plan;
                la pregunta real es si puede costear el accidente que este plan previene.
            </div>

            <div className="keep-blankspace" />
            <ManCrossPageFooter />
        </div>
    );
};

export default ManCrossPageRoiRiesgo;
